<template>
  <div class="office-search bg-gray-100 flex items-start gap-4 p-4">
    <div class="w-full relative">
      <input type="text" id="office-search-input" class="w-full" />
      <div
        v-if="!!this.filters.place"
        @click="clearPlace"
        class="absolute right-2 x cursor-pointer"
      >
        X
      </div>
    </div>

    <div class="map-list-left-container" v-if="!!highlighted.length">
      <Button
        @click="listType == 'offices' ? deselectAll() : $emit('askOffer')"
        class="black"
        >{{ listType == "offices" ? "Mégse" : "Érdeklődöm" }}</Button
      >
    </div>
    <div class="map-list-right-container" v-if="!!highlighted.length">
      <Button @click="toggleList" class="black">{{
        listType == "offices" ? "Kosár" : "Összes"
      }}</Button>
    </div>

    <div class="map-list-switch-container">
      <Button
        @click="
          showMap = !showMap;
          $emit('showMobileMap', showMap);
        "
        class="blue"
        >{{ showMap ? "Lista" : "Térkép" }}</Button
      >
    </div>

    <div class="filter-container">
      <Button
        @click="
          showFilter = !showFilter;
          refreshSlider();
          showSorting = false;
        "
        class="blue"
        >Szűrés</Button
      >
      <div
        class="office-filters fixed bg-gray-100 rounded-2xl z-10 p-4"
        v-show="showFilter"
      >
        <div class="grid grid-flow-row grid-cols-2">
          <div>
            <h4 class="mt-1">Offie rating</h4>
            <input
              type="number"
              v-model="filters.offieRatingFrom"
              class="w-10"
              placeholder="min"
              min="0"
              max="10"
            />
            -
            <input
              type="number"
              v-model="filters.offieRatingTo"
              class="w-10"
              placeholder="max"
              min="0"
              max="10"
            />
          </div>
          <div>
            <h4 class="mt-1">Havi bérleti díj</h4>
            <input
              type="number"
              v-model="filters.priceFrom"
              class="w-10"
              placeholder="min"
              min="0"
              max="1000000"
            />
            -
            <input
              type="number"
              v-model="filters.priceTo"
              class="w-10"
              placeholder="max"
              min="0"
              max="1000000"
            />
          </div>
          <div class="relative col-span-2">
            <h4>Maximum távolság a címtől</h4>
            <span class="maxdistancetext text-xs absolute"
              >{{ filters.maxDistance }} m</span
            >
          </div>
          <div class="maxdistanceslider col-span-2">
            <vue-range-slider
              ref="slider"
              v-model="filters.maxDistance"
              :min="1000"
              :max="10000"
              :piecewise="true"
              :piecewise-style="{
                backgroundColor: '#B0AFAF',
                width: '6px',
                height: '10px'
              }"
              :piecewise-active-style="{ backgroundColor: '#525252' }"
              :enable-cross="false"
              :height="6"
              :dot-height="20"
              :dot-width="20"
              :tooltip-style="{ display: 'none' }"
              :step="3000"
            ></vue-range-slider>
          </div>
          <div class="col-span-2">
            <h4>Kerület</h4>
            <label class="checkbox-container district" for="district-i"
              >I.
              <input
                type="checkbox"
                id="district-i"
                v-model="filters.district"
                value="I"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-ii"
              >II.
              <input
                type="checkbox"
                id="district-ii"
                v-model="filters.district"
                value="II"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-iii"
              >III.
              <input
                type="checkbox"
                id="district-iii"
                v-model="filters.district"
                value="III"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-iv"
              >IV.
              <input
                type="checkbox"
                id="district-iv"
                v-model="filters.district"
                value="IV"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-v"
              >V.
              <input
                type="checkbox"
                id="district-v"
                v-model="filters.district"
                value="V"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-vi"
              >VI.
              <input
                type="checkbox"
                id="district-vi"
                v-model="filters.district"
                value="VI"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-vii"
              >VII.
              <input
                type="checkbox"
                id="district-vii"
                v-model="filters.district"
                value="VII"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-viii"
              >VIII.
              <input
                type="checkbox"
                id="district-viii"
                v-model="filters.district"
                value="VIII"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-ix"
              >IX.
              <input
                type="checkbox"
                id="district-ix"
                v-model="filters.district"
                value="IX"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-x"
              >X.
              <input
                type="checkbox"
                id="district-x"
                v-model="filters.district"
                value="X"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xi"
              >XI.
              <input
                type="checkbox"
                id="district-xi"
                v-model="filters.district"
                value="XI"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xii"
              >XII.
              <input
                type="checkbox"
                id="district-xii"
                v-model="filters.district"
                value="XII"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xiii"
              >XIII.
              <input
                type="checkbox"
                id="district-xiii"
                v-model="filters.district"
                value="XIII"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xiv"
              >XIV.
              <input
                type="checkbox"
                id="district-xiv"
                v-model="filters.district"
                value="XIV"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xv"
              >XV.
              <input
                type="checkbox"
                id="district-xv"
                v-model="filters.district"
                value="XV"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xvi"
              >XVI.
              <input
                type="checkbox"
                id="district-xvi"
                v-model="filters.district"
                value="XVI"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xvii"
              >XVII.
              <input
                type="checkbox"
                id="district-xvii"
                v-model="filters.district"
                value="XVII"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xviii"
              >XVIII.
              <input
                type="checkbox"
                id="district-xviii"
                v-model="filters.district"
                value="XVIII"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xix"
              >XIX.
              <input
                type="checkbox"
                id="district-xix"
                v-model="filters.district"
                value="XIX"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xx"
              >XX.
              <input
                type="checkbox"
                id="district-xx"
                v-model="filters.district"
                value="XX"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xxi"
              >XXI.
              <input
                type="checkbox"
                id="district-xxi"
                v-model="filters.district"
                value="XXI"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xxii"
              >XXII.
              <input
                type="checkbox"
                id="district-xxii"
                v-model="filters.district"
                value="XXII"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container district" for="district-xxiii"
              >XXIII.
              <input
                type="checkbox"
                id="district-xxiii"
                v-model="filters.district"
                value="XXIII"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div>
            <h4>Mélygarázs</h4>

            <label class="checkbox-container" for="underground-garage"
              >Elérhető az irodához
              <input
                type="checkbox"
                id="underground-garage"
                v-model="filters.undergroundGarage"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div>
            <h4>Osztály</h4>
            <label class="checkbox-container class" for="office-class-b"
              >B
              <input
                type="checkbox"
                id="office-class-b"
                v-model="filters.class"
                value="B"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container class" for="office-class-b-plus"
              >B+
              <input
                type="checkbox"
                id="office-class-b-plus"
                v-model="filters.class"
                value="B+"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container class" for="office-class-a"
              >A
              <input
                type="checkbox"
                id="office-class-a"
                v-model="filters.class"
                value="A"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container class" for="office-class-a-plus"
              >A+
              <input
                type="checkbox"
                id="office-class-a-plus"
                v-model="filters.class"
                value="A+"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="mobileview-sorting col-span-2">
            <h4>Rendezés Offie Rating szerint</h4>

            <label class="checkbox-container radio block" for="sort-rating-asc"
              >Offie Rating szerint növekvő
              <input
                type="radio"
                id="sort-rating-asc"
                v-model="sort"
                value="offieRating:asc"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container radio block" for="sort-rating-desc"
              >Offie Rating szerint csökkenő
              <input
                type="radio"
                id="sort-rating-desc"
                v-model="sort"
                value="offieRating:desc"
              />
              <span class="checkmark"></span>
            </label>

            <h4>Rendezés ár szerint</h4>

            <label class="checkbox-container radio block" for="sort-price-asc"
              >Ár szerint növekvő
              <input
                type="radio"
                id="sort-price-asc"
                v-model="sort"
                value="priceTo:asc"
              />
              <span class="checkmark"></span>
            </label>

            <label class="checkbox-container radio block" for="sort-price-desc"
              >Ár szerint csökkenő
              <input
                type="radio"
                id="sort-price-desc"
                v-model="sort"
                value="priceTo:desc"
              />
              <span class="checkmark"></span>
            </label>

            <h4>Rendezés távolság szerint</h4>

            <label
              class="checkbox-container radio block"
              for="sort-distance-asc"
              >Legközelebb a címhez
              <input
                type="radio"
                id="sort-distance-asc"
                v-model="sort"
                value="distance:asc"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <Button @click="applyFilters" class="blue w-full">Szűrés</Button>
      </div>
    </div>
    <!-- <Button class="blue">Keresés</Button> -->
    <div class="sorting-container">
      <Button
        @click="
          showSorting = !showSorting;
          showFilter = false;
        "
        class="superwhite"
        >Rendezés</Button
      >
      <div
        class="office-sorting fixed bg-gray-100 rounded-2xl z-10 p-4"
        v-show="showSorting"
      >
        <h4 class="mt-0">Rendezés Offie Rating szerint</h4>

        <label class="checkbox-container radio block" for="sort-rating-asc"
          >Offie Rating szerint növekvő
          <input
            type="radio"
            id="sort-rating-asc"
            v-model="sort"
            value="offieRating:asc"
          />
          <span class="checkmark"></span>
        </label>

        <label class="checkbox-container radio block" for="sort-rating-desc"
          >Offie Rating szerint csökkenő
          <input
            type="radio"
            id="sort-rating-desc"
            v-model="sort"
            value="offieRating:desc"
          />
          <span class="checkmark"></span>
        </label>

        <h4>Rendezés ár szerint</h4>

        <label class="checkbox-container radio block" for="sort-price-asc"
          >Ár szerint növekvő
          <input
            type="radio"
            id="sort-price-asc"
            v-model="sort"
            value="priceTo:asc"
          />
          <span class="checkmark"></span>
        </label>

        <label class="checkbox-container radio block" for="sort-price-desc"
          >Ár szerint csökkenő
          <input
            type="radio"
            id="sort-price-desc"
            v-model="sort"
            value="priceTo:desc"
          />
          <span class="checkmark"></span>
        </label>

        <h4>Rendezés távolság szerint</h4>

        <label class="checkbox-container radio block" for="sort-distance-asc"
          >Legközelebb a címhez
          <input
            type="radio"
            id="sort-distance-asc"
            v-model="sort"
            value="distance:asc"
          />
          <span class="checkmark"></span>
        </label>

        <Button @click="applyFilters" class="blue w-full">Rendezés</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Button from "@/components/inputs/Button.vue";
import VueRangeSlider from "vue-range-component";
import "vue-range-component/dist/vue-range-slider.css";

let google;

export default {
  name: "OfficeSearchBar",
  components: { Button, VueRangeSlider },
  data() {
    return {
      showFilter: false,
      showSorting: false,
      showMap: false,
      autocomplete: null,
      place: "",
      filters: {
        place: null,
        offieRatingFrom: null,
        offieRatingTo: null,
        priceFrom: null,
        priceTo: null,
        maxDistance: 4000,
        district: [],
        undergroundGarage: false,
        class: []
      },
      sort: "distance:asc"
    };
  },
  computed: {
    ...mapState({
      highlighted: state => state.offices.highlighted,
      listType: state => state.offices.listType
    })
  },
  methods: {
    initGoogle(googleInstance) {
      google = googleInstance;
      const input = document.getElementById("office-search-input");
      const options = {
        fields: ["formatted_address", "geometry", "name"],
        componentRestrictions: { country: "hu" },
        strictBounds: false
        // types: ["establishment"],
      };

      const autocomplete = new google.maps.places.Autocomplete(input, options);
      this.autocomplete = autocomplete;

      autocomplete.addListener("place_changed", () => {
        this.filters.place = autocomplete.getPlace();

        if (!this.filters.place) {
          const { place, ...rest } = this.filters;
          this.filters = rest;
          input.value = "";
        }

        this.$emit("updated", this.filters);
        // if (
        //   this.filters.place.geometry &&
        //   this.filters.place.geometry.location
        // ) {
        // }
      });
    },
    refreshSlider() {
      setTimeout(() => {
        this.$refs.slider.refresh();
      }, 150);
    },
    applyFilters() {
      this.showFilter = false;
      this.showSorting = false;

      this.$emit("updated", this.filters, this.sort);
    },
    clearPlace() {
      this.autocomplete.set("place", null);
    },
    closeFilter() {
      this.showFilter = false;
    },
    toggleList() {
      this.$store.commit("offices/toggleListType");
    },
    deselectAll() {
      this.$store.commit("offices/deselectAll");
    }
  },
  activated() {
    this.$refs.slider.refresh();
  },
  deactivated() {
    this.$refs.slider.unbindEvents();
  }
};
</script>

<style lang="scss">
.office-search {
  grid-area: search;
  border-radius: 16px;
}

.x {
  top: 50%;
  transform: translate(-50%, -50%);
}

.map-list-left-container {
  position: fixed;
  bottom: 72px;
  left: calc(50% - 130px);
  z-index: 10;

  button {
    width: 129px;
    border-radius: 10px 0 0 10px;
    box-shadow: -4px 2px 10px 2px $midgray;
  }

  @media (min-width: $breakpoint2) {
    display: none;
  }
}

.map-list-right-container {
  position: fixed;
  bottom: 72px;
  left: calc(50% + 1px);
  z-index: 10;

  button {
    width: 129px;
    border-radius: 0 10px 10px 0;
    box-shadow: 4px 2px 10px 2px $midgray;
  }

  @media (min-width: $breakpoint2) {
    display: none;
  }
}

.map-list-switch-container {
  position: fixed;
  bottom: 20px;
  left: calc(50% - 100px);
  z-index: 10;

  button {
    width: 99px;
    border-radius: 10px 0 0 10px;
    box-shadow: -4px 2px 10px 2px $midgray;
  }

  @media (min-width: $breakpoint2) {
    display: none;
  }
}

.filter-container {
  @media (max-width: $breakpoint2) {
    position: fixed;
    bottom: 20px;
    left: calc(50% + 1px);
    z-index: 10;

    button {
      width: 99px;
      border-radius: 0 10px 10px 0;
      box-shadow: 4px 2px 10px 2px $midgray;
    }
  }
}

.sorting-container {
  display: none;

  @media (min-width: $breakpoint2) {
    display: block;
  }
}

.office-filters,
.office-sorting {
  margin-right: 20px;
  margin-top: 28px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.25);

  h4 {
    font-weight: 700;
    font-size: 18px;
    line-height: 17px;
    color: #525252;
  }
}

.office-filters {
  left: 1rem;

  .maxdistancetext {
    top: 55px;
    // left: 10px;
  }

  .mobileview-sorting {
    display: none;
  }

  .maxdistanceslider {
    .vue-range-slider {
      padding: 10px 0px !important;
    }
  }
  @media (max-width: $breakpoint2) {
    top: 0;
    overflow-y: scroll;
    max-height: calc(100% - 20px);

    h4 {
      font-size: 15px;
    }

    .maxdistancetext {
      top: 45px;
    }

    .maxdistanceslider {
      grid-column: span 2 / span 2;
    }

    .grid {
      margin-bottom: 100px;
      gap: 5px;
    }

    .button.blue {
      position: fixed;
      bottom: 10px;
      width: 80%;
      padding: 15px;
      border-radius: 10px;
    }

    .mobileview-sorting {
      display: block;
    }
  }

  @media (min-width: $breakpoint2) {
    left: 50%;
    max-height: calc(100vh - 236px);
    overflow-y: scroll;
  }

  @media (min-width: 1200px) {
    left: 66%;
  }
}

.office-sorting {
  right: 0;
}

input {
  background: #ffffff;
  border-radius: 10px;
  padding: 10px;
  border: 0;
}

#office-search-input {
  box-sizing: border-box;
  padding: 10px 15px;
  height: 48px;
  font-weight: 400;
  font-size: 18px;
}

.vue-range-slider.slider-component .slider .slider-process {
  border-radius: 0;
  background-color: #575b6c;
}
.vue-range-slider.slider-component .slider {
  border-radius: 12px;
  background-color: #b0afaf;
}
.vue-range-slider.slider-component .slider .slider-dot .slider-dot-handle {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  background-color: #3152f6;
}

.checkbox-container {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding-left: 30px;
  margin-bottom: 20px;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #525252;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &.district {
    width: 90px;
  }
  &.class {
    width: 58px;
  }
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox-container .checkmark {
  position: absolute;
  top: -3px;
  left: 0;
  height: 18px;
  width: 18px;
  box-sizing: border-box;
  border: 2px solid #525252;
  border-radius: 3px;
  background-color: transparent;
}

.checkbox-container.radio .checkmark {
  border-radius: 50%;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #5973f8;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #525252;
}

.checkbox-container.radio input:checked ~ .checkmark {
  background: rgb(82, 82, 82);
  background: radial-gradient(
    circle,
    rgba(82, 82, 82, 1) 50%,
    rgba(48, 48, 48, 0) 50%,
    rgba(0, 0, 0, 0) 100%
  );
}

.checkbox-container .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 3px;
  top: -1px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.checkbox-container.radio .checkmark:after {
  left: 3px;
  top: -1px;
  width: 5px;
  height: 10px;
  border: none;
  border-radius: 50%;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}
</style>
